<template>
  <a-modal :title="$t('确定发送此图片吗?')" :visible="visible" @ok="handleOk" @cancel="handleCancel">
    <img :src="imgSrc" style="max-width: 100%" />
  </a-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { setSaveChat } from '@/api/pushSend'

export default {
  name: 'PasteImgModal',
  data() {
    return {
      visible: false,
      imgSrc: '',
      file: null,
    }
  },
  computed: {
    ...mapGetters({
      // 判断是否正式登录
      token: 'token',
      currentSession: 'chat/currentSession',
      currentUser: 'chat/currentUser',
      otherUserInfo: 'chat/otherUserInfo',
    }),
  },
  mounted() {
    console.log('paste_mounted')
    document.addEventListener('paste', this.pasteEvent)
  },
  unmounted() {
    console.log('paste_destroyed')
    document.removeEventListener('paste', this.pasteEvent)
  },
  methods: {
    ...mapActions({
      addMessage: 'chat/addMessage',
    }),
    pasteEvent(event) {
      const that = this

      const items = event.clipboardData && event.clipboardData.items
      that.file = null
      if (items && items.length) {
        // 检索剪切板items
        for (let i = 0; i < items.length; i++) {
          if (items[i].type.includes('image')) {
            that.file = items[i].getAsFile()
            console.log('file', that.file)

            // 图片预览模块
            const reader = new FileReader()
            reader.onload = function (event) {
              // event.target.result就是图片的Base64地址啦
              console.log('图片的Base64地址啦', event, event.target.result)
              that.imgSrc = event.target.result
              that.visible = true
            }
            reader.readAsDataURL(that.file)

            console.log(that.file)
            break
          }
        }
      }
    },
    handleOk() {
      // 大小
      const isLt2M = this.file.size / (1024 * 1024) > 10
      if (isLt2M) {
        this.$message.error(this.$t('图片大小不可以超过 10MB!'))
        return
      }

      const that = this

      const ext = {
        sendUrl:
          (that.currentUser.company && that.currentUser.company.logo) ||
          that.currentUser.avatar ||
          that.currentUser.selectedAvatarUrl ||
          '',
        sendName:
          (that.currentUser.company && that.currentUser.company.companyName) ||
          (that.currentUser.memberCard && that.currentUser.memberCard.contact) ||
          '',
        receiveUrl: that.otherUserInfo.pic || '',
        receiveName:
          that.otherUserInfo.companyName || that.otherUserInfo.contact || that.otherUserInfo.mchcompanyName || '',
        em_ignore_notification: '1',
      }

      const url = window.URL.createObjectURL(this.file)
      const id = this.$WebIM.conn.getUniqueId() // 生成本地消息id

      const msg = new this.$WebIM.message('img', id) // 创建图片消息
      msg.set({
        file: { data: that.file, url },
        to: that.otherUserInfo.huanxinId, // 接收消息对象
        ext,
        chatType: 'singleChat',
        onFileUploadError(error) {
          that.$message.error('图片上传失败')
          that.file = null
          console.log('图片上传失败', error)
        },
        onFileUploadComplete(data) {
          console.log('onFileUploadComplete')
        },
        success(id) {
          console.log('发送成功')

          const msgInfo = {
            is_self: 1,
            from: that.currentUser.id,
            to: that.currentSession.id,
            url,
            contentsType: 'IMAGE',
            time: new Date().getTime(),
          }

          msgInfo.id = id
          that.addMessage(msgInfo)

          const saveInfo = {
            toMemberCode:
              that.otherUserInfo.memunicode || that.otherUserInfo.memUnicode || that.otherUserInfo.huanxinId,
            lastMessage: '[图片]',
          }

          setSaveChat(saveInfo)
        },
        fail(e) {
          // TODO 后期添加日志
          console.log('Fail') // 如禁言、拉黑后发送消息会失败
          that.$message.error('图片上传失败')
          that.file = null
          this.visible = false
        },
      })
      this.$WebIM.conn.send(msg.body)

      this.visible = false
    },
    handleCancel() {
      this.visible = false
      this.imgSrc = ''
    },
  },
}
</script>
